import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import "../../assets/stylesheets/free-consult.css";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import i18n from 'i18next';
import {ContactInfoContext} from "./ContactInfoContext";

function FreeConsult() {
    const { t } = useTranslation(["freeconsult"]);
    const { contactInfo } = useContext(ContactInfoContext);

    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("freeCons")}`} />
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("freeCons")}`} />
                <meta property="og:title" content={t("freeTitle")} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:description" content={t("freeDescribe")} />
                <meta property="og:image" content={Logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta name="description" content={t("freeDescribe")} />
                <title>{t("freeTitle")}</title>
            </Helmet>
            <div className="consult-page">
                <div className="about-start-consult">
                    <img src={contactInfo.consultUrl} alt="Free Consultation" />
                </div>

                <div className="main-container-consult">
                    <div className="headings-consult">
                        <h1>
                            <em>{t("freeConsult")}</em>
                        </h1>
                    </div>

                    <p className="content-consult">{t("freeConsultText")}</p>
                </div>
            </div>
        </>
    );
}

export default FreeConsult;